export default __webpack_public_path__ + "static/media/layers.ffe795bd.svg";